<div class="relative text-theme-text">
  <div *ngIf="isWorking" class="absolute bottom-30 z-50 flex w-full justify-center">
    <app-loading-spinner size="lg"></app-loading-spinner>
  </div>
  <div class="relative">
    <img *ngIf="item.pic" [src]="item.pic" [alt]="item.name" class="w-full rounded-2xl object-cover mt-2 mb-2" [ngClass]="{'h-64': !isExpanded}" (click)="toggleExpand()"/>
<!--    <div *ngIf="item.pic"-->
<!--         class="absolute top-1 right-1 w-8 h-8 rounded-full cursor-pointer text-white flex items-center justify-center"-->
<!--         (click)="toggleExpand()">-->
<!--      <i class="fa" [ngClass]="isExpanded ? 'fa-compress' : 'fa-search-plus'"></i>-->
<!--    </div>-->

    <div class="">
      <p class="text-xl font-medium text-theme-text2 tabular-nums flex items-center gap-2">
        <span class="inline-flex items-center gap-1.5"><i *ngIf="isTakeawayPrice(item)" class="fa-solid fa-person-carry-box text-base"></i>{{getPrice(item)}}</span>
        <span *ngIf="getTakeawayPrice(item) as tp" class="text-base bg-theme-surface2 rounded-xl px-2 inline-flex items-center gap-1"><i class="fa-solid fa-person-carry-box text-sm"></i>{{tp}}</span>
      </p>
      <div class="flex flex-row">
        <p class="mt-2 text-base tracking-wide text-theme-text">{{item.desc}}</p>
      </div>
    </div>
  </div>

  <div class="text-theme-text3 text-sm mt-4" *ngIf="item.contains">
   <i class="fa-solid fa-seedling mr-1"></i> <span *ngFor="let con of item.contains; let last = last;" [ngClass]="selCons[con.id] ? 'line-through' : ''">{{getString(con.name, "upper")}}{{last ? "" : ", "}}</span>
  </div>

  <div *ngIf="showTweak && mode === 'add'">
    <app-link-button *ngIf="!tweaksOpen" [text]="getString('Anpassa')" (onClick)="openTweaks()" rightIcon="fa-circle-chevron-down" color="text-theme-text2" ></app-link-button>
    <div *ngIf="tweaksOpen" class="rounded-lg my-2 p-4 bg-theme-surface2">
<!--      <button mat-button color="primary" class="tweak-button2" (click)="openTweaks()">{{getString("Anpassa rätten (allergier och innehåll)")}}</button>-->
      <div class="mb-3 -mt-1">
        <app-link-button [text]="getString('Anpassa')" (onClick)="openTweaks()" rightIcon="fa-circle-chevron-up" color="text-theme-text2"></app-link-button>
      </div>
      <div class="tweak-contains">
        <div class="my-1" *ngFor="let con of item.contains; let last = last;">
          <app-checkbox-label [(ngModel)]="selCons[con.id]" [disabled]="!con.del">
            <div *ngIf="con.del">
              {{getString("utan", "cap")}} {{getString(con.name)}}<ng-container *ngIf="con.info"> - {{con.info}}</ng-container>
            </div>
            <div *ngIf="!con.del">
              {{getString("Går inte att få utan")}} {{getString(con.name)}}
            </div>
          </app-checkbox-label>
        </div>

        <div *ngIf="item.adjusts" class="mt-4">
          <div class="my-1" *ngFor="let adj of item.adjusts; let last = last;">
            <app-checkbox-label [(ngModel)]="selAdjs[adj.id]">
              {{getString("utan", "cap")}} {{getString(adj.name)}}
            </app-checkbox-label>
          </div>

        </div>

        <div *ngIf="hiddenAttributes().length>0">
          <div class="mt-4 mb-1 font-bold text-sm text-theme-text2"> {{ getString("Övriga anpassningar") }}:</div>
          <div *ngFor="let attribute of hiddenAttributes(); let atri = index, let lastatr = last">
            <ng-container *ngTemplateOutlet="attributeContent; context: { $implicit: attribute, values: attrValues, scope: '' }"></ng-container>
            <app-separator *ngIf="!lastatr"></app-separator>
          </div>
        </div>

        <!--        <div *ngIf="hiddenAttributes().length>0" style="margin-top: 16px;">-->
<!--          <div class="adj-title">Övriga anpassningar:</div>-->
<!--          <label class="clickable-area" *ngFor="let attribute of hiddenAttributes(); let atri = index; let lastatr = last;">-->
<!--            <mat-radio-group *ngIf="attribute.options.length>1" [(ngModel)]="attrValues[attribute.id]">-->
<!--              <label class="clickable-area" style="margin-top: 8px;font-size: 16px;" *ngFor="let option of attribute.options; let opti = index; let lastopt = last;">-->
<!--                <mat-radio-button [value]="option.key"><span class="atr-name">{{option.value}}</span><span> {{option.formatted}}</span></mat-radio-button>-->
<!--              </label>-->
<!--            </mat-radio-group>-->
<!--            <label class="clickable-area">-->
<!--              <mat-checkbox *ngIf="attribute.options.length===1;" [(ngModel)]="attrValues[attribute.id]">-->
<!--                <div><span class="atr-name">{{attribute.options[0].value}}</span><span style="font-size: 16px;"> {{attribute.options[0].formatted}}</span></div>-->
<!--              </mat-checkbox>-->
<!--            </label>-->
<!--            <div class="item-separator" style="margin-top: 16px"></div>-->
<!--          </label>-->
<!--        </div>-->

      </div>
    </div>
  </div>

  <div *ngIf="item.attributes && mode !== 'display'" class="font-bold text-xl mt-8 mb-4">{{ getString("Välj tillval") }}</div>


  <!-- Attributes container -->
  <div *ngIf="item.attributes && mode !== 'display'" class="mt-4 flex flex-col gap-4">
    <!-- Loop through attributes -->
    <div *ngFor="let attribute of visibleAttributes(); let atri = index, let lastatr = last">
      <ng-container *ngTemplateOutlet="attributeContent; context: { $implicit: attribute, values: attrValues, scope: '' }"></ng-container>
      <app-separator *ngIf="!lastatr"></app-separator>
    </div>
  </div>

  <!-- Package: the fixed parts' own attributes, then each choice with its picks' attributes -->
  @if (item.package && mode !== 'display') {
    @for (view of pkgFixedViews; track view.part.key) {
      <ng-container *ngTemplateOutlet="partAttributes; context: { $implicit: view }"></ng-container>
    }
    @for (choice of item.package.choices ?? []; track $index; let ci = $index) {
      <div class="mt-8">
        <div class="font-bold text-xl">{{choice.title}}</div>
        <div class="text-sm text-theme-text2 mt-1 mb-4">
          {{getString("Välj")}} {{choice.count}}@if (choice.count > 1) { · {{choiceRemaining(ci)}} {{getString("kvar")}}}
        </div>
        <div class="flex flex-col gap-2" (click)="hideVis()">
          @for (option of choice.options; track option.id) {
            @if (choice.count === 1) {
              <!-- Pick one: radio -->
              <label class="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-theme-surface2 border-2"
                     [class.border-theme-primary]="choiceOptionCount(ci, option) > 0"
                     [class.border-theme-surface2]="choiceOptionCount(ci, option) === 0"
                     (click)="selectChoiceOption(ci, option); $event.stopPropagation();">
                <div class="flex items-center gap-3 w-full">
                  <div class="relative w-4 h-4 flex items-center justify-center">
                    <div [class]="choiceOptionCount(ci, option) > 0 ? 'fas fa-circle-dot text-theme-primary fa-lg' : 'far fa-circle text-theme-primary fa-lg'"></div>
                  </div>
                  <div class="flex-grow w-full text-theme-primary flex justify-between items-center">
                    <span [class.font-bold]="choiceOptionCount(ci, option) > 0"
                          [class.font-medium]="choiceOptionCount(ci, option) === 0">{{option.name}}</span>
                    @if (choiceSurcharge(choice, option); as sc) {
                      <span class="tabular-nums">{{sc}}</span>
                    }
                  </div>
                </div>
              </label>
            } @else {
              <!-- Pick several (repeats allowed): steppers, as for a multi attribute -->
              <div class="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-theme-surface2 border-2"
                   [class.border-theme-primary]="choiceOptionCount(ci, option) > 0"
                   [class.border-theme-surface2]="choiceOptionCount(ci, option) === 0"
                   (click)="toggleChoiceVis(ci, option); $event.stopPropagation();">
                <div class="-ml-2 mr-2">
                  <app-plus-minus-micro-button
                    [maxCount]="choice.count"
                    [totalCount]="choice.count - choiceRemaining(ci)"
                    [amount]="choiceOptionCount(ci, option)"
                    [remaining]="choiceRemaining(ci)"
                    [disabled]="choiceOptionCount(ci, option) === 0 && choiceRemaining(ci) <= 0"
                    [blocked]="blockUI"
                    (onChangeVis)="toggleChoiceVis(ci, option)"
                    (onChangeAmount)="changeChoiceCount(ci, option, $event)"
                    [vis]="visKey === 'choice' + ci + '||' + option.id"
                  ></app-plus-minus-micro-button>
                </div>
                <div class="flex-grow w-full text-theme-primary flex justify-between items-center"
                     [class.opacity-50]="choiceOptionCount(ci, option) === 0 && choiceRemaining(ci) <= 0">
                  <span class="font-medium">{{option.name}}</span>
                  @if (choiceSurcharge(choice, option); as sc) {
                    <span class="tabular-nums">{{sc}}</span>
                  }
                </div>
              </div>
            }
          }
        </div>
        @for (view of pkgChoiceViews[ci]; track view.part.key) {
          <ng-container *ngTemplateOutlet="partAttributes; context: { $implicit: view }"></ng-container>
        }
      </div>
    }
  }

  <div *ngIf="readableWhen" class="text-theme-text2 text-lg font-medium mt-12">
    <i class="far fa-clock mr-2"></i>{{readableWhen}}
  </div>

  <div *ngIf="!kitchenOpen" class="text-theme-text2 text-lg font-medium mt-12">
    <i class="far fa-utensils-slash mr-2"></i>{{getString("Köket är stängt")}}
  </div>
  <div *ngIf="outOfStock" class="text-theme-text2 text-lg font-medium mt-12">
    <i class="far fa-xmark mr-2"></i>{{getString("Slutsåld")}}
  </div>
  <div *ngIf="!venueOpen" class="text-theme-text2 text-lg font-medium mt-12">
    <i class="far fa-cart-circle-xmark mr-2"></i>{{getString("Stängt för beställning")}}
  </div>
  <div *ngIf="venueOpen && kitchenOpen && !outOfStock && mode==='add' && prepTime" class="text-theme-text2 text-lg font-medium mt-12">
    <i class="far fa-hourglass mr-2"></i>Cirka {{prepTime}} {{ getString("minuter tillagningstid") }}
  </div>

  <!-- Fixed bottom navigation -->
  <div class="py-4 mt-8">
    <!-- Centered content wrapper -->
    <div class="max-w-lg mx-auto">
      <div class="flex flex-row justify-between gap-4" *ngIf="venueOpen && kitchenOpen && !outOfStock">
        <app-plus-minus-button *ngIf="canEditCount" [(count)]="itemCount"></app-plus-minus-button>
        <app-small-action-button *ngIf="mode==='add'" class="flex-grow" [customClass]="'w-full border border-theme-primary whitespace-nowrap'" [text]="getString('Lägg till')" (onClick)="addNewItem()" [disabled]="isWorking || !packageComplete()"></app-small-action-button>
        <app-small-action-button *ngIf="mode==='pick'" class="flex-grow" [customClass]="'w-full border border-theme-primary whitespace-nowrap'" [text]="(getString('Välj') + ' ' + getPrice(item)).trim()" (onClick)="pickPackage()" [disabled]="!packageComplete()"></app-small-action-button>
        <app-small-action-button *ngIf="mode==='edit'" class="flex-grow" [customClass]="'w-full border border-theme-primary whitespace-nowrap'" [text]="getString('Uppdatera') + ' ' + getPrice(item)" (onClick)="updateItem()" [disabled]="isWorking || !packageComplete()"></app-small-action-button>
      </div>
    </div>
  </div>

</div>

<!-- One package part's own attributes, under its name -->
<ng-template #partAttributes let-view>
  <div class="mt-6 pl-3 border-l-2 border-theme-text3/30">
    <div class="font-bold text-base mb-3">{{view.label}}</div>
    <div class="flex flex-col gap-4">
      @for (attribute of view.attributes; track attribute.id; let lastatr = $last) {
        <div>
          <ng-container *ngTemplateOutlet="attributeContent; context: { $implicit: attribute, values: view.part.attrValues, scope: view.part.key, inPackage: true }"></ng-container>
          <app-separator *ngIf="!lastatr"></app-separator>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- An attribute of the item (scope '') or of a package part (scope = part key, absolute option prices not shown) -->
<ng-template #attributeContent let-attribute let-values="values" let-scope="scope" let-inPackage="inPackage">

  <!-- multi quantity attribute -->
  <div *ngIf="attribute.multi" class="flex flex-col gap-2" (click)="hideVis()">
    <!-- Each radio option -->

    <div>Välj {{attribute.multi.max}} {{attribute.multi.unit}}</div>
    <div *ngFor="let option of attribute.options" (click)="toggleVis(values,scope,attribute,option); $event.stopPropagation();"
           class="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-theme-surface2 border-2"
           [class.border-theme-primary]="getAttributeValue(values, attribute.id, option.key) !== 0"
           [class.border-theme-surface2]="getAttributeValue(values, attribute.id, option.key) === 0"
           >

      <div class="-ml-2 mr-2">
        <app-plus-minus-micro-button
          [maxCount]="attribute.multi.max"
          [totalCount]="getTotalAttributeCount(values, attribute)"
          [unit]="attribute.multi.unit"
          [amount]="getAttributeValue(values, attribute.id, option.key)"
          [remaining]="getRemainingSelectionCount(values, attribute)"
          [disabled]="getAttributeValue(values, attribute.id, option.key) === 0 && getRemainingSelectionCount(values, attribute) <= 0"
          [blocked]="blockUI"
          (onChangeVis)="toggleVis(values,scope,attribute,option)"
          (onChangeAmount)="onChangeAmount(values,attribute,option,$event)"
          [vis]="isVis(scope, attribute, option)"
        ></app-plus-minus-micro-button>
      </div>

      <div class="flex items-center w-full" [class.opacity-50]="getAttributeValue(values, attribute.id, option.key) === 0 && getRemainingSelectionCount(values, attribute) <= 0">
        <!-- Option content -->
        <div class="flex-grow w-full text-theme-primary">
          <div class="flex justify-between items-center">
            <span class="font-medium">{{option.value}}</span>
            <span *ngIf="optionPriceShown(option, inPackage)" class="tabular-nums">{{option.formatted}}</span>
          </div>
          <div *ngIf="option.desc" class="text-sm opacity-75">{{option.desc}}</div>
          <div *ngIf="option.contains" class="text-sm opacity-75">
            {{getString("INNEHÅLLER", "upper")}}
            <span *ngFor="let con of option.contains; let last = last">
                  {{getString(con.name, "upper")}}{{con.del ? "*" : ""}}{{last ? "" : ", "}}
                </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Radio buttons for multiple options -->
  <div *ngIf="attribute.options.length > 1 && !attribute.multi" class="flex flex-col gap-2">
    <!-- Each radio option -->
    <label *ngFor="let option of attribute.options"
           class="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-theme-surface2 border-2"
           [class.border-theme-primary]="values[attribute.id] === option.key"
           [class.border-theme-surface2]="values[attribute.id] !== option.key"
           [class.text-stone-800]="values[attribute.id] !== option.key">

      <input type="radio"
             [name]="'attr-' + scope + '-' + attribute.id"
             [value]="option.key"
             [(ngModel)]="values[attribute.id]"
             class="hidden">

      <div class="flex items-center gap-3 w-full">
        <div class="relative w-4 h-4 flex items-center justify-center">
          <div *ngIf="values[attribute.id] === option.key"
               class="fas fa-circle-dot text-theme-primary fa-lg">
          </div>
          <div *ngIf="values[attribute.id] !== option.key"
               class="far fa-circle text-theme-primary fa-lg">
          </div>
        </div>

        <!-- Option content -->
        <div class="flex-grow w-full text-theme-primary">
          <div class="flex justify-between items-center">
            <span [class.font-bold]="values[attribute.id] == option.key"
                  [class.font-medium]="values[attribute.id] !== option.key">{{option.value}}</span>
            <span *ngIf="optionPriceShown(option, inPackage)" class="tabular-nums">{{option.formatted}}</span>
          </div>
          <div *ngIf="option.desc" class="text-sm/5 opacity-75">{{option.desc}}</div>
          <div *ngIf="option.contains" class="mt-1 text-sm/5 opacity-75">
            <i class="fa-solid fa-seedling mr-1"></i>
            <span *ngFor="let con of option.contains; let last = last">
                  {{getString(con.name, "upper")}}{{con.del ? "*" : ""}}{{last ? "" : ", "}}
                </span>
          </div>
        </div>
      </div>
    </label>
  </div>

  <!-- Checkbox for single option -->
  <div *ngIf="attribute.options.length === 1 && !attribute.multi">
    <label class="flex items-center px-4 py-2 rounded-lg cursor-pointer bg-theme-surface2 border-2"
           [class.border-theme-primary]="values[attribute.id]"
           [class.border-theme-surface2]="!values[attribute.id]"
           [class.text-stone-800]="values[attribute.id]">

      <input type="checkbox"
             [(ngModel)]="values[attribute.id]"
             class="hidden">

      <div class="flex items-center gap-3 w-full">
        <div class="relative w-4 h-4 flex items-center justify-center">
          <i *ngIf="values[attribute.id]" class="fas fa-square-check text-theme-primary fa-lg"></i>
          <i *ngIf="!values[attribute.id]" class="far fa-plus-square text-theme-primary fa-lg"></i>
        </div>

        <!-- Option content -->
        <div class="flex-grow text-theme-primary w-full transition duration-300 ">
          <div class="flex justify-between items-center">
            <span
            [class.font-bold]="values[attribute.id]"
            [class.font-medium]="!values[attribute.id]">{{attribute.options![0].value}}</span>
            <span *ngIf="optionPriceShown(attribute.options![0], inPackage)" class="tabular-nums">
                  {{attribute.options![0].formatted}}
                </span>
          </div>
          <div *ngIf="attribute.options![0].desc" class="text-sm/5 opacity-75">
            {{attribute.options![0].desc}}
          </div>
          <div *ngIf="attribute.options![0].contains" class="mt-1 text-sm/5 opacity-75">
            <i class="fa-solid fa-seedling mr-1"></i>
            <span *ngFor="let con of attribute.options![0].contains; let last = last">
                  {{getString(con.name, "upper")}}{{con.del ? "*" : ""}}{{last ? "" : ", "}}
                </span>
          </div>
        </div>
      </div>
    </label>
  </div>
</ng-template>
